"use client";

import Image from "next/image";

 {/* <svg className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 inset-0 w-[100%] h-[100%] max-w-none" viewBox="0 0 638.94 1192.19" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
        
        <defs>

          <clipPath id="shapeClip" clipPathUnits="userSpaceOnUse">
            <path d="M930.8,159.16v879.9c-5.66-3.15-12.09-6.87-19.17-11.13h0L625.73,839,429.89,709.51l87.53-53.08c20.69-12.26,41-24.26,60.37-35.94l34.94-21.39-34.94-21.36c-19.41-11.68-39.68-23.68-60.37-35.94l-87.53-53.09L625.73,359.27l285.88-189h0C918.71,166,925.14,162.32,930.8,159.16Z"
              transform="translate(-292.26 -3.02)"
            />
            <polygon points="0 450.71 60.09 487.16 99.38 510.99 238.29 595.22 239.73 596.08 238.29 596.97 99.38 681.2 60.09 705.02 0 741.47 0 450.71" />
          </clipPath>
        </defs>


        <foreignObject width="100%" height="100%" clipPath="url(#shapeClip)">
          <div className="w-full h-full">
            <Image src={imageSrc} alt="Clipped to shape" fill className="object-cover" />
          </div>
        </foreignObject>


        <polygon points="13.73 410.57 638.55 0 638.94 103.37 97.05 461.1 13.73 410.57" fill="#ccb070" />
        <polygon points="97.05 731.09 638.94 1088.83 638.55 1192.19 13.73 781.62 97.05 731.09" fill="#ccb070" />

      </svg> */}

{/* <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 525.99 483.85"
        className="w-full h-full"
      >
        <defs>
          <clipPath id="blueClip">
            <path
              d="M619.28,0V309.85L606.5,332c-71.1,123.15-228.57,165.34-351.72,94.24S89.44,197.66,160.54,74.51L203.56,0Z"
              transform="translate(-93.29 0)"
            />
          </clipPath>
        </defs>

 
        <path
          d="M611.28,0V325.37l-13.42,23.25c-74.66,129.32-240,173.63-369.34,99s-173.63-240-99-369.34L174.73,0Z"
          transform="translate(-93.29 0)"
          fill="#e0d514"
        />

        <image
          href={imageSrc}
          clipPath="url(#blueClip)"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
        />
      </svg> */}

 {/* <svg className="w-130 h-auto" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 547.15 500.1">
        <path d="M434.1,533.16C333.41,584.07,204.45,561.8,127,466.1c-74.37-91.86-73-226.37,3.61-317.15C209.76,55.16,337.94,36.39,435.83,87.11,365,144.48,326,218.18,325.64,309.74,325.3,401.15,363.6,475.08,434.1,533.16Z" transform="translate(-72.13 -59.61)"/>
        <path d="M619.28,100.16V65.84q-6.46-.32-13-.29c-136.45.54-246.18,106.69-246.42,244.66-.25,139.46,110.08,244.53,246.77,246.31q6.36,0,12.65-.32V521.46c-44.64,2.63-88.56-8.91-123.55-31.5,49.36-49.48,76-108.84,76.33-179s-25.64-129.83-74.84-180C532.42,108.49,575.65,97.56,619.28,100.16Z" transform="translate(-72.13 -59.61)"/>
      </svg> */}

 {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 344.27 522.51"
        className="w-full h-[100vh]"
      >
        <g transform="scale(5) translate(-50 -50)">
        <defs>
          
          <clipPath id="clip-shape">
            <path
              d="M442.17,552.29c-46,0-81.47-36-82.71-83.91-1.17-45.32-30.87-82.24-74.87-92-10.8-2.39-22.21-1.87-33.21-3.56-43.2-6.67-72.8-44-70.08-88,2.58-41.69,37.54-75.48,80.34-76.39,31-.67,56.72-11.68,76.5-35.64,14.28-17.28,21.05-37.33,21.39-59.79.63-41.36,28.21-74.21,68.3-81.85,45.88-8.74,90.35,23.73,96.82,70.69,6.31,45.82-27.92,88.85-73.85,93.15-12.27,1.15-24.95,1.53-36.62,5C369.11,213.51,341,258.24,347.6,304.33c6.7,47.11,45.71,81.16,94.65,82.6,41.76,1.23,74.33,28.2,81.57,67.54A82.54,82.54,0,0,1,442.17,552.29Z"
              transform="translate(-181.13 -29.79)"
            />
          </clipPath>
        </defs>
        </g>


        <image
          href={imageSrc}
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          clipPath="url(#clip-shape)"
        />

        <path
          fill="#d8d8d8"
          d="M258.82,535.79a63.87,63.87,0,1,1,64-64A63.64,63.64,0,0,1,258.82,535.79Z"
          transform="translate(-181.13 -29.79)"
        />
        <path
          fill="#d8d8d8"
          d="M509.9,292.83a67.56,67.56,0,0,1-135.11-.5c-.15-36.72,30.56-67.52,67.29-67.5A67.44,67.44,0,0,1,509.9,292.83Z"
          transform="translate(-181.13 -29.79)"
        />
      </svg> */}

   {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 411.73 621.92"
        className="w-[200%] h-[200%] -mr-25"
      >
        <defs>
         
          <clipPath id="clip-shape" clipPathUnits="userSpaceOnUse">
              <path
              d="M456.14,631.52c-22.55-.44-45-8-62.14-22.76-40.28-34.56-47.4-95.17-82.86-134.65-32.22-35.88-81-48.49-121.84-71.47-28.13-15.85-46.74-46.56-47.62-78.95a95,95,0,0,1,33.5-74.33c20.49-17.15,47.09-24.7,71.15-36.33A223.25,223.25,0,0,0,348.49,111.69c11.34-23,18.89-48.31,35.11-68.17,32-39.2,97-45.49,136-13.15s44.63,97.36,11.89,136c-43.6,51.39-132.2,49-169.3,105.26C339.51,306,345.65,355.44,373.8,385.47c42.78,45.63,121.07,45,160.27,93.72,29.59,36.79,24.41,96.29-10.44,128.15C505.45,624,480.73,632,456.14,631.52Z"
              transform="translate(-141.64 -9.62)"
            />

            <path
          d="M537.73,322.64c-.08,44.63-36.52,80.88-81.29,80.87A81.65,81.65,0,0,1,374.84,322c-.19-44.21,36.84-81.31,81.13-81.28A81.26,81.26,0,0,1,537.73,322.64Z"
          transform="translate(-141.64 -9.62)"
          fill="#d8d8d8"
        />

          </clipPath>
        </defs>


        <image
          href={imageSrc}
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          clipPath="url(#clip-shape)"
        />

        <path
          fill="none"
          stroke="rgba(255,255,255,0.0)"
          d="M456.14,631.52c-22.55-.44-45-8-62.14-22.76-40.28-34.56-47.4-95.17-82.86-134.65-32.22-35.88-81-48.49-121.84-71.47-28.13-15.85-46.74-46.56-47.62-78.95a95,95,0,0,1,33.5-74.33c20.49-17.15,47.09-24.7,71.15-36.33A223.25,223.25,0,0,0,348.49,111.69c11.34-23,18.89-48.31,35.11-68.17,32-39.2,97-45.49,136-13.15s44.63,97.36,11.89,136c-43.6,51.39-132.2,49-169.3,105.26C339.51,306,345.65,355.44,373.8,385.47c42.78,45.63,121.07,45,160.27,93.72,29.59,36.79,24.41,96.29-10.44,128.15C505.45,624,480.73,632,456.14,631.52Z"
          transform="translate(-141.64 -9.62)"
        />


        
      </svg> */}

{/* <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 585.22 621.92"
        className="w-[110%] h-[110%] block overflow-visible"
      >
        <defs>
          <clipPath id="shape-clip" clipPathUnits="userSpaceOnUse">
            <path
              d="M575.63,607.34C557.45,624,532.73,632,508.14,631.52c-22.55-.44-45-8-62.14-22.76-40.28-34.56-47.4-95.17-82.86-134.65-12-13.34-26.26-23.47-41.58-32.11a29.9,29.9,0,0,1-12.85,11.46,171.37,171.37,0,1,1,2.82-247.39,223.51,223.51,0,0,0,89-94.38c11.34-23,18.89-48.31,35.11-68.17,32-39.2,97-45.49,136-13.15s44.63,97.36,11.89,136c-43.6,51.39-107.2,49-144.3,105.26C416.51,306,422.65,355.44,450.8,385.47c42.78,45.63,96.07,45,135.27,93.72C615.66,516,610.48,575.48,575.63,607.34Z"
              transform="translate(-20.15 -9.62)"
            />
          </clipPath>
        </defs>

        <image
          href={imageSrc}
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          clipPath="url(#shape-clip)"
        />
      </svg> */}

{/* <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 550.68 621.92"
        className="w-[130%] h-[130%] block overflow-visible"
      >
        <defs>
          <clipPath id="shapeClip" clipPathUnits="userSpaceOnUse">
            <path
              d="M575.63,607.34C557.45,624,532.73,632,508.14,631.52c-22.55-.44-45-8-62.14-22.76-40.28-34.56-47.4-95.17-82.86-134.65-12-13.34-26.26-23.47-41.58-32.11-.52.84-1.07,1.66-1.66,2.44h0a44.42,44.42,0,0,1-62.07,32.23c-.67-.31-1.34-.63-2-1-1.37-.7-2.2-.75-3.14.1a5.12,5.12,0,0,0-.59.62A44.64,44.64,0,0,1,199.89,489a65.51,65.51,0,0,1-18.23-11.3c-.28-.25-.54-.52-.79-.79a28,28,0,0,1-17.52-4,61.37,61.37,0,0,1-9.89,1,43.9,43.9,0,0,1-43.79-41.65,2.57,2.57,0,0,0-2.23-2.8c-10.28-3-19.48-8-26.44-16.22-11.17-13.1-14-28-8.39-44.43.27-.78.52-1.57.81-2.33l.28-.71c1.08-2.8.94-3-1.41-5l-.41-.34c-13.38-11.18-19.33-25.41-16.5-42.69,2.12-13,9.14-23.07,20.33-30.13l1.41-.87c-1.35-5.18-3.07-9.89-3.74-14.73C69.91,246.51,89.29,223.32,114.9,222c2-.11,2.53-.73,2.71-2.69,2.15-23.84,24.62-42.08,48.39-39.44a43.05,43.05,0,0,1,14.54,4c1.45.71,2,.3,2.78-.93,7.23-11.48,17.54-18.59,30.91-20.79,14.39-2.37,27,1.86,37.68,11.67a43.32,43.32,0,0,1,10.17,14.53c1.86-.64,3.63-1.24,5.39-1.86a44.41,44.41,0,0,1,51,15.44,223.5,223.5,0,0,0,82-90.25c11.34-23,18.89-48.31,35.11-68.17,32-39.2,97-45.49,136-13.15s44.63,97.36,11.89,136c-43.6,51.39-71.2,49-108.3,105.26C452.51,306,458.65,355.44,486.8,385.47c42.78,45.63,60.07,45,99.27,93.72C615.66,516,610.48,575.48,575.63,607.34Z"
              transform="translate(-54.69 -9.62)"
            />
          </clipPath>
        </defs>


        <image
          href={imageSrc}
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          clipPath="url(#shapeClip)"
        />
      </svg> */}
  
{/* <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 539.87 618.86"
        className="w-[140%] h-[140%]" 
      >
        <defs>
          <clipPath id="clip-shape" clipPathUnits="userSpaceOnUse">
            <path d="M254.8,213.3c-1,.5-1.9.9-2.9,1.4.2-.5.3-1,.5-1.5A19.27,19.27,0,0,1,254.8,213.3Z" transform="translate(-65.4 -11.14)" />
            <path d="M65.68,316.14a14.55,14.55,0,0,0-.2,4.33c.56,5.4,4.28,9.87,7.84,14,40.69,40.69,76.76,88.18,114.15,131.94,36.74,43,74,85.56,111,128.29,9.12,10.51,18.56,21.27,31,27.57,15.28,7.77,33.17,7.84,50.31,7.74l204-1.17c4.94,0,10.16-.13,14.37-2.73,6.79-4.2,8.52-13.75,6.18-21.39s-7.79-13.85-12.93-20c-67.75-80.49-91.11-182.93-158.07-264.07,66.56-81,89.56-183.11,157-263.31,4.94-5.87,10.14-11.81,12.63-19.07s1.55-16.3-4.38-21.17c-4.93-4.06-11.87-4.31-18.27-4.36L384.73,11.18c-15.79-.13-32-.19-46.82,5.17C316.65,24,300.86,41.72,286,58.76L74.67,301.18C70.82,305.59,66.77,310.59,65.68,316.14Z" transform="translate(-65.4 -11.14)" />
          </clipPath>
        </defs>


        <image
          href={imageSrc}
          x="0"
          y="0"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          clipPath="url(#clip-shape)"
        />
      </svg> */}


// export default function ClippedImage({ imageSrc }) {
//   return (
//     <div className="relative w-full h-full flex items-start justify-start overflow-visible">

//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         viewBox="0 0 249.13 339.35"
//         className="absolute inset-0 w-[120%] h-[120%]"
//       >
//         <defs>
//           <clipPath id="clip-shape" clipPathUnits="objectBoundingBox">
//             <path
//               transform="scale(0.0040,0.00295) translate(-190.67 -146.08)"
//               d="M317.76,402.61V146.08c1.79,1.08,3.38,2,4.95,3q32.79,20.37,65.59,40.71a3.18,3.18,0,0,1,1.59,3.17q0,78.53.16,157.05c0,2-.07,4,.06,6.05a3.07,3.07,0,0,1-1.76,3.11Q362.66,375,337,390.85l-17.47,10.81C319.07,402,318.56,402.18,317.76,402.61Z"
//             />
//             <path
//               transform="scale(0.0040,0.00295) translate(-190.67 -146.08)"
//               d="M312.66,230.9V485.42c-3.44-2.08-6.62-4-9.78-5.94q-30.24-18.56-60.48-37.08a3.67,3.67,0,0,1-2-3.61q.15-80.58.18-161.18a3.47,3.47,0,0,1,1.76-3.51q34.29-21,68.51-42.17C311.37,231.6,311.93,231.32,312.66,230.9Z"
//             />
//             <path
//               transform="scale(0.0040,0.00295) translate(-190.67 -146.08)"
//               d="M394.28,198.6c4.51,2.81,8.78,5.46,13,8.13,10.2,6.39,20.39,12.81,30.62,19.15A3.18,3.18,0,0,1,439.7,229q0,51.16.1,102.33c0,1.25-.05,2.28-1.37,3.1-14.11,8.7-28.18,17.49-42.26,26.25-.53.33-1.1.59-1.89,1Z"
//             />
//             <path
//               transform="scale(0.0040,0.00295) translate(-190.67 -146.08)"
//               d="M236.17,444.82l-8.71-5.34c-11.65-7.19-23.28-14.41-35-21.55a3.34,3.34,0,0,1-1.83-3.27q.12-50.7.09-101.42a3.33,3.33,0,0,1,1.81-3.26q21.08-13,42.06-26.11c.42-.26.86-.49,1.54-.87Z"
//             />
//           </clipPath>
//         </defs>

//         {/* IMAGE CLIPPED INSIDE SVG */}
//         <image
//           href={imageSrc}
//           width="100%"
//           height="100%"
//           preserveAspectRatio="xMidYMid slice"
//           clipPath="url(#clip-shape)"
//         />
//       </svg>
//     </div>
//   );
// }


export default function ClippedImage({ imageSrc }) {
  return (
    <div className="relative w-full h-[400px] md:h-full md:-mr-50 overflow-visible">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 335.85 345.41"
        className="w-[130%] h-[130%]"
      >
        <defs>
          {/* ✅ CLIP MASK WITH MULTIPLE PATHS */}
          <clipPath id="multiShape" clipPathUnits="userSpaceOnUse">
            <path d="M216.31,332.26c-10.4,0-20.8-.06-31.2.05a4.54,4.54,0,0,1-4.69-2.73C174.79,319,169,308.47,163.3,297.91c-4-7.33-7.86-14.7-11.83-22a3.22,3.22,0,0,1-.07-3.55c9.89-18,19.75-36,29.43-54.11,1.6-3,3.29-4.11,6.79-4.07,20.36.2,40.73.08,61.09.13a2.79,2.79,0,0,1,2,1.18c4.32,7.2,8.58,14.45,12.83,21.69q6.94,11.82,13.86,23.67c2,3.38,3.89,6.8,5.87,10.19a2.81,2.81,0,0,1,.1,3.11c-4.58,8.27-9.09,16.58-13.64,24.86q-4,7.18-8,14.34-4.69,8.46-9.39,16.92a3.59,3.59,0,0,1-3.36,2.2c-10.9,0-21.8,0-32.69,0Z" transform="translate(-150.9 -151.64)" />
            <path d="M321.12,151.91q13.9,0,27.82,0a38,38,0,0,1,4.65-.05,3.49,3.49,0,0,1,2.32,1.37q4.36,7.49,8.48,15.11c7,12.94,13.86,25.93,20.88,38.84a4.35,4.35,0,0,1,0,4.78c-3.68,6.49-7.22,13.06-10.8,19.61q-8.18,14.94-16.33,29.89c-1.1,2-2.1,4.1-3.33,6a3,3,0,0,1-2.12,1.3c-12.88.07-25.77,0-38.66,0-8.21,0-16.43,0-24.65.06a2.44,2.44,0,0,1-2.47-1.43Q278,252.22,269,237c-4.5-7.67-8.94-15.38-13.49-23-1.14-1.91-1.5-3.51-.3-5.66,6.14-11,12.08-22,18.17-33,2.3-4.15,4.86-8.16,7.2-12.29q2.63-4.61,5-9.37a3.45,3.45,0,0,1,3.59-2c8.15.08,16.31.08,24.46.11h7.47Z" transform="translate(-150.9 -151.64)" />
            <path d="M373.57,243.92l14.83-26.56a5.71,5.71,0,0,1,6.42-3.79l57.92.15a7.88,7.88,0,0,1,3.83.67,7.75,7.75,0,0,1,2.7,3.32l26,48.1a6.76,6.76,0,0,1,.09,8.31L458.78,323c-.9,1.64-1.89,3.38-3.55,4.24a9.48,9.48,0,0,1-4.4.7l-52.95,0c-2.26,0-4.66,0-6.55-1.29A11.63,11.63,0,0,1,388,322.5L370.9,293.08l-8.7-15c-2.88-4.94-3.31-7.89-.4-13.1Z" transform="translate(-150.9 -151.64)" />
            <path d="M322.68,273.15c10.39,0,20.79,0,31.19,0a2.91,2.91,0,0,1,2.93,1.77q10.08,18.71,20.25,37.36c2.69,5,5.3,10,8.05,15a3.44,3.44,0,0,1,0,3.77Q374,351.26,362.89,371.58c-2.41,4.42-4.89,8.81-7.21,13.28a3,3,0,0,1-3.17,1.86c-20.3-.05-40.59,0-60.89-.08a2.78,2.78,0,0,1-2-1.23q-5.43-8.94-10.69-18c-6.87-11.76-13.69-23.56-20.59-35.31a3,3,0,0,1,0-3.28c6-10.9,11.9-21.84,17.91-32.72,3.93-7.1,8-14.11,12-21.2a3.48,3.48,0,0,1,3.44-2c10.33,0,20.66,0,31,0Z" transform="translate(-150.9 -151.64)" />
            <path d="M423.63,332.51c9.65,0,19.3.05,28.95,0a4,4,0,0,1,4.14,2.33c4.29,8.06,8.76,16,13.11,24.07,4.65,8.59,9.21,17.22,13.85,25.81a3.31,3.31,0,0,1,.05,3.6c-7.56,13.73-15,27.51-22.53,41.27-2,3.66-4,7.3-6,11a2.42,2.42,0,0,1-2.46,1.5c-19.74,0-39.48,0-59.21-.07a2.57,2.57,0,0,1-1.85-1.1q-6.77-11.26-13.4-22.63c-5.58-9.56-11.09-19.16-16.71-28.7a3,3,0,0,1,0-3.42c5.91-10.8,11.76-21.63,17.69-32.42,3.52-6.4,7.16-12.74,10.75-19.1a3.7,3.7,0,0,1,3.49-2.27c10,.07,20.05,0,30.07,0Z" transform="translate(-150.9 -151.64)" />
            <path d="M337.32,391.9l17.06,0a5.26,5.26,0,0,1,5.9,3.3L386,439c1,1.66,2,3.43,1.87,5.35a9.82,9.82,0,0,1-1.57,4.21l-25.21,45.11a7,7,0,0,1-2.33,2.81,6.77,6.77,0,0,1-3.41.58L298.06,497a8.55,8.55,0,0,1-3.86-.61,8.65,8.65,0,0,1-3.13-3.55L276.54,468.2l-7.27-12.29c-1.66-2.81-6.06-7.74-5.94-11.06.14-3.52,4.74-9,6.45-12.05q3.48-6.26,7-12.51,7-12.46,14.06-24.88l.05-.08a5.22,5.22,0,0,1,5.86-3.3Z" transform="translate(-150.9 -151.64)" />
          </clipPath>
        </defs>

        {/* ✅ IMAGE CLIPPED BY MULTIPLE-PATH SHAPE */}
        <image
          href={imageSrc}
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          clipPath="url(#multiShape)"
        />
      </svg>
    </div>
  );
}
